import React, { memo } from 'react';
import styled from 'styled-components';

import PickupIcon from 'assets/v2/PickupIcon';
import { COLORS } from 'theme';
import { BOOKING_TYPE_TIME_LABELS } from 'utils/constants';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.selectiveYellowDark};
    background: ${COLORS.selectiveYellowLight};
    border-color: ${COLORS.selectiveYellow};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.selectiveYellow};
    }
  }
`;

function PickupTimeBookingTypeTag(props) {
  return (
    <StyledTag
      label={BOOKING_TYPE_TIME_LABELS.SCHEDULED}
      icon={<PickupIcon />}
      {...props}
    />
  );
}

export default memo(PickupTimeBookingTypeTag);
